import { useState, type MouseEvent } from "react";
import { NavLink } from "react-router";
import { canAccessLiquidity } from "../config/liquidity-access";
import { bridgeReviewEnabled } from "../config/bridge";
import { launchpadPagesEnabled } from "../config/navigation";
import type { WalletView } from "../state/context-view-types";
import { MenuIcon } from "./Icons";
import { Overlay } from "./overlays/Overlay";

export function PageNavigation({ wallet }: { wallet?: Pick<WalletView, "address" | "status"> }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  function onNavigate(event: MouseEvent<HTMLElement>) {
    // Close only after NavLink has intercepted the click for client-side routing.
    if (!event.defaultPrevented) return;
    if (event.target instanceof Element && event.target.closest("a[href]")) close();
  }

  const links = <>
    <NavLink to="/" end>Terminal</NavLink>
    <NavLink to="/tasks">Tasks</NavLink>
    <NavLink to="/trade">Trade</NavLink>
    {bridgeReviewEnabled() && <NavLink to="/bridge">Bridge</NavLink>}
    {canAccessLiquidity(wallet) ? <NavLink to="/liquidity">Liquidity</NavLink> : null}
    {launchpadPagesEnabled ? <NavLink to="/explore" end>Explore</NavLink> : <button type="button" disabled title="Temporarily unavailable">Explore</button>}
    {launchpadPagesEnabled ? <NavLink to="/create" end>Create</NavLink> : <button type="button" disabled title="Temporarily unavailable">Create</button>}
  </>;

  return <>
    <nav className="page-navigation page-navigation-desktop" aria-label="Main navigation">
      {links}
    </nav>
    <button type="button" className="icon-button page-menu-toggle" aria-label="Open menu"
      aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>
      <MenuIcon />
    </button>
    <Overlay open={open} onClose={close} title="Menu" variant="sheet" className="page-menu" closeIcon={<MenuIcon />}>
      <nav className="page-navigation" aria-label="Main navigation" onClick={onNavigate}>
        {links}
      </nav>
    </Overlay>
  </>;
}
